// 获取url参数
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r;
  if (window.location.search == '') {
    if (window.location.hash != "" && window.location.hash != "#/") {
      r = window.location.hash.split("?")[1].match(reg);
    }
  } else {
    r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  }
  // console.log(r)
  var context = "";
  if (r != null) context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined"
    ? ""
    : context;
};
// 判断平台
export const judgePlateFrom = () => {
  if (/AlipayClient/.test(window.navigator.userAgent)) {
    //判断是否是支付宝浏览器打开
    console.log("支付宝客户端");
    return "alipay";
  }

  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    console.log("微信浏览器");
    return "wechat";
  }

  return "undefined";
};

// 判断平台-电脑环境
export const isDesktopEnvironment = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent;

  // 是否触摸设备
  const hasTouch = navigator.maxTouchPoints > 0;

  // iPhone / Android 手机
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);

  // iPad / Android 平板 / iPadOS(mac伪装)
  const isTablet =
    /iPad|Tablet/i.test(ua) ||
    (
      ua.includes('Macintosh') &&
      hasTouch
    ) ||
    (
      hasTouch &&
      window.innerWidth >= 768 &&
      window.innerWidth <= 1366
    );

  // 真正桌面 Mac（iPhone UA 自带 "like Mac OS X"，只能匹配 Macintosh）
  const isMacDesktop =
    /Macintosh/i.test(ua) &&
    !hasTouch;

  // Windows / Linux 桌面（安卓 UA 自带 "Linux"，需排除安卓）
  const isDesktopOS =
    /Windows NT|X11/i.test(ua) ||
    (/Linux/i.test(ua) && !/Android/i.test(ua));

  return isMacDesktop || isDesktopOS || (!isMobile && !isTablet);
};

// 判断平台
export const isWechat = () => {
  //是否是微信浏览器
  if (/(micromessenger)/i.test(navigator.userAgent)) {
    //是否电脑微信或者微信开发者工具
    if (/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)) {
      return true;
    } else {
      //手机微信打开的浏览器
      return true;
    }
  } else {
    return false;
  }
};

// 判断是否微信小程序环境
export const isWeChatMiniProgram = () => {
  if (typeof wx !== 'undefined' && typeof wx.getSystemInfo === 'function') {
    return true;
  }
  if (typeof uni !== 'undefined' && uni.getSystemInfoSync) {
    return uni.getSystemInfoSync().platform === 'wechat';
  }
  return false;
}


// 判断是否ios机型
export const checkDevice = () => {
  const ua = window.navigator.userAgent;

  const ios =
    /iPad|iPhone|iPod/i.test(ua);

  const ipadOS =
    ua.includes("Mac")

  return ios || ipadOS;
};

// 获取 iPhone 的 iOS 主版本号(从 UA 的 "iPhone OS 26_0" / "CPU iPhone OS 16_5" 提取),非 iPhone 环境返回 -1
export const getIOSVersion = () => {
  const ua = window.navigator.userAgent;
  const match = ua.match(/iPhone OS (\d+)[._](\d+)/);
  return match ? parseInt(match[1], 10) : -1;
};

// 判断是否webapp
export const isInStandaloneMode = () => {
  if ((window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://')) {
    return true;
  } else {
    return false
  }
}

// 判断返回游戏链接是否有参数
export function hasQueryParams(url) {
  const [beforeHash] = url.split("#");
  return beforeHash.includes("?");
}

//获取所有url参数
export function GetUrlParam() {
  let url = document.location.toString();
  let arrObj = url.split("?");
  let params = Object.create(null)
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split("&");
    arrObj.forEach(item => {
      item = item.split("=");
      params[item[0]] = item[1]
    })
  }
  return params;
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 判断机型
export const detectDevice = () => {
  const ua = navigator.userAgent.toLowerCase();

  // 1. Windows 桌面（保持最高优先级）
  if (/\bWindows\b/i.test(ua)) {
    return 3;
  }

  // 2. 鸿蒙
  if (/openharmony/i.test(ua)) {
    return 7;
  }

  // 3. iOS 设备（iPhone / iPod）
  if (/iphone|ipod/i.test(ua) && !window.MSStream) {
    return 1;
  }

  // 4. iPad（重点改进！）
  //    iOS 13+ 的 iPad UA 为桌面 Mac 格式，需结合 maxTouchPoints 判断
  if (
    (/ipad/i.test(ua)) ||   // 旧版 iPad（仍含 "iPad" 关键词）
    (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) // 新版 iPad
  ) {
    return 1;   // 统一返回 iOS（1），你也可以单独定义 9 等
  }

  // 5. Android（手机/平板）
  if (/android/i.test(ua)) {
    return 2;
  }

  // 6. Mac 桌面（确认非 iPad）
  if (
    /macintosh|mac os/i.test(ua) &&
    navigator.maxTouchPoints <= 1
  ) {
    return 8;
  }

  // 7. Linux 桌面
  if (/linux/i.test(ua)) {
    return 10;
  }

  return 11; // 未知
};
